<script>
	import FilterList from './filteredlist.svelte';

	export let lists;
	export let params;
</script>

<style>
	.cont {
		text-align: center;
	}
	.wrap {
		text-align: left;
	}
</style>

<div class="cont">
<div class="wrap inblock">
{#each lists as it}
	{#if it.list.length}
	<FilterList
		bind:data={it}
		params={params}
		on:setActSong
		on:deleteSong
	/>
	{/if}
{/each}
</div>
</div>
